"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsoleMessageListener = exports.NullMessageListener = void 0;
var NullMessageListener = /** @class */ (function () {
    function NullMessageListener() {
    }
    NullMessageListener.prototype.onMessage = function (_source, _code, _severity, _message) {
        // do nothing
    };
    return NullMessageListener;
}());
exports.NullMessageListener = NullMessageListener;
var ConsoleMessageListener = /** @class */ (function () {
    function ConsoleMessageListener(logSourceOnTrace) {
        if (logSourceOnTrace === void 0) { logSourceOnTrace = false; }
        this.logSourceOnTrace = logSourceOnTrace;
    }
    ConsoleMessageListener.prototype.onMessage = function (source, code, severity, message) {
        // eslint-disable-next-line no-console
        var print = severity === 'Error' ? console.error : console.log;
        var content = "".concat(severity, ": [").concat(code, "] ").concat(message);
        if (severity === 'Trace' && this.logSourceOnTrace) {
            content += "\n<<<<< SOURCE:\n".concat(JSON.stringify(source), "\n>>>>>");
        }
        print(content);
    };
    return ConsoleMessageListener;
}());
exports.ConsoleMessageListener = ConsoleMessageListener;
//# sourceMappingURL=messageListeners.js.map